import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Box, Typography, ButtonBase } from "@mui/material";

import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";

function AddGraphButton() {
  const { t } = useTranslation();
  return (
    <ButtonBase component={Link} to={{ pathname: "/analyser" }}>
      <Box
        sx={{
          width: "320px",
          height: "160px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          border: "1px solid rgba(0,0,0,0.2)",
          borderRadius: 1,
          gap: 1,
        }}
      >
        <AddCircleOutlineOutlinedIcon fontSize="small" />
        <Typography variant="button">{t("moodboards.buttons.add")}</Typography>
      </Box>
    </ButtonBase>
  );
}

export default AddGraphButton;
